import React from "react";
import PropTypes from "prop-types";
import Modal, { MODAL_SIZE } from "components/Modal";
import { ProfilesList } from "components/Profiles";

/**
 * ProfilesPicker
 * Reusable modal for selecting profiles (members)
 * Can be used for termsheets, teams, lists, etc.
 *
 * @param {Boolean}    loading       - Whether the modal is in a loading state
 */
const ProfilesPicker = ({ loading, ...props }) => (
  <Modal secondaryButtonMessageId="Global.Close" size={MODAL_SIZE.medium} showCancel loading={loading} {...props}>
    <ProfilesList allowedFilters={["search"]} disableRowOptions {...props} />
  </Modal>
);

ProfilesPicker.propTypes = {
  loading: PropTypes.bool,
};

export default ProfilesPicker;
